import * as React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SxProps, Theme, styled } from '@mui/material/styles';
import Lottie from 'lottie-react';

import hourGlassAnimation from '../../../assets/animations/hourglass_2.json';
import icons from '../../../themes/icons';
import { OfferStatus } from '../../../API';

const Container = styled(Box)(() => ({
  position: 'absolute',
  top: 8,
  left: 8,
  backgroundColor: 'rgba(0, 0, 0, .8)',
  color: 'white',
  borderRadius: '50px',
  padding: '5px 16px',
  boxShadow: '0px 0px 4px 0px #00000040',
}));

const InReviewBadge = styled(Box)(() => ({
  position: 'absolute',
  top: 8,
  left: 8,
  backgroundColor: '#FFFFFF',
  borderRadius: '50px',
  paddingRight: '15px',
  border: '1px solid #DBAF3E',
  height: '36.89px',
  paddingLeft: '3px',
  zIndex: 1,
}));

type HighlightProps = {
  privateOffer: boolean;
  eventOffer: boolean;
  sx?: SxProps<Theme>;
  status?: OfferStatus
};

const Highlight: React.FC<HighlightProps> = ({ privateOffer, eventOffer, sx, status }) => {
  const pending = status === OfferStatus.pending;

  if (pending) {
    return (
      <InReviewBadge sx={sx}>
        <Stack direction='row' alignItems='center' style={{ marginTop: '-4px' }}>
          <Lottie
            animationData={hourGlassAnimation}
            loop
            style={{ width: 40, height: 42 }}
          />
          <Typography
            variant='caption'
            component='div'
            fontSize={'15px'}
            fontWeight={500}
            color='#232832'
            padding={0}
          >
            In review
          </Typography>
        </Stack>
      </InReviewBadge>
    );
  }

  return (
    <Container
      sx={{
        border: eventOffer
          ? '1px solid #FFCE50'
          : privateOffer
            ? '1px solid #7B7BFF'
            : '1px solid #6CC2AD',
        ...sx,
      }}
    >
      <Stack direction='row' alignItems='center' spacing={1}>
        {eventOffer ? (
          <icons.EventOfferIcon style={{ width: '22px', height: '22px' }} />
        ) : privateOffer ? (
          <icons.CollabOfferIcon style={{ width: '22px', height: '22px' }} />
        ) : (
          <icons.RecruitOfferIcon style={{ width: '22px', height: '22px' }} />
        )}

        <Typography
          variant='caption'
          component='div'
          fontSize={'15px'}
          fontWeight={500}
          color={eventOffer ? '#FFCE50' : privateOffer ? '#9B9BFF' : '#37BB90'}
          padding={0}
        >
          {eventOffer ? 'Event' : privateOffer ? 'Collab offer' : 'Recurring offer'}
        </Typography>
      </Stack>
    </Container>
  );
};

export default Highlight;
